export const DA_DAT_LICH = 0;

export const DA_TEST_GENERAL = 1;

export const DA_TEST_SPEAKING = 2;

export const CHO_CHAM_DIEM = 3;

export const DA_TRA_KET_QUA = 4;

export const HUY_LICH = 5;



// Trạng thái sơ bộ (chi tiết ca test sơ bộ)

export const STATUS_CAN_TEST_GEN_LABEL = 'Cần test general';

export const STATUS_CAN_TEST_SPEAKING_LABEL = 'Cần test speaking';

export const STATUS_CAN_DANG_KY_THI_DAU_KHOA_LABEL = 'Cần đăng ký thi đầu khóa';

export const STATUS_DA_TEST_SPEAKING_LABEL = 'Đã test speaking';

export const STATUS_DA_TRA_KET_QUA_SO_BO_LABEL = 'Đã trả kết quả';

export const STATUS_DA_DANG_KY_THI_DAU_KHOA_LABEL = 'Đã đăng ký thi đầu khóa';



export const STATUS_DA_BO_QUA_KIEM_TRA_LABEL = 'Đã bỏ qua kiểm tra';
